import { posListResponseSchema } from '@/features/pos/services/schemas.ts';
import { mockPosList } from './mocks.ts';
import { ApiClient } from '@/common/api/ApiClient.ts';

export const PosService = {
  list: async () => {
    return await ApiClient.get('/pos', posListResponseSchema, undefined, {
      mock: mockPosList,
    });
  },
};
